// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class Accordion extends Vue {
  private isExpanded: boolean = false;

  @Prop()
  public value!: boolean;

  public $refs!: {
    head: HTMLElement;
    body: HTMLElement;
  };

  @Watch("value")
  public watchValue(value, oldValue) {
    if (value != this.isExpanded) {
      this.isExpanded = value;
    }
  }

  public created() {
    if (this.value != this.isExpanded) {
      this.isExpanded = this.value;
    }
  }

  public toggle(e: Event) {
    // value true = open, false = closed
    if (this.isExpanded) {
      this.isExpanded = false;
      this.$emit("input", false);
      this.$emit("close");
    } else {
      this.isExpanded = true;
      this.$emit("input", true);
      this.$emit("open");
    }
  }
}
